/**
 * Return asset URL
 *
 * @param path
 */
export const asset = (path: string): string => {
  return path ? `${process.env.REACT_APP_IMAGE_PREFIX}${path}` : ''
}
